import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type AccommodationPlaceRecommendationFragment = {
  __typename?: 'AccommodationPlaceRecommendation';
  id: string;
  status: Types.AccommodationPlaceRecommendationStatus;
  whyThisHotelIsAGreatPick?: string | null;
  proposedNoteFromHostToGuest?: string | null;
  highlightTags?: Array<string> | null;
  venueGooglePlaceId?: string | null;
};

export type AccommodationRoomBlockFragment = {
  __typename?: 'AccommodationPlaceRoomBlock';
  bookingUrl: string;
  checkInDate: string;
  checkOutDate: string;
  cutoffDate: string;
  isJoyManagedRoomBlock: boolean;
  numberOfRoomsReserved: number;
  status: Types.AccommodationPlaceRoomBlockStatus;
  pricePerNight?: number | null;
  strikeoutPricePerNight?: number | null;
};

export type TravelDistanceBetweenPointsFragment = {
  __typename?: 'TravelDistanceBetweenPoints';
  durationMinutes?: number | null;
  km: number;
  mi: number;
  type: Types.DistancesBetweenPointsType;
};

export type TravelDistancesBetweenPointsResponseFragment = {
  __typename?: 'TravelDistancesBetweenPointsResponse';
  commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }>;
};

export type AccommodationPlaceV2Fragment = {
  __typename: 'AccommodationPlaceV2';
  id: string;
  type?: Types.AccommodationPlaceType | null;
  userNote?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  email?: string | null;
  phone?: string | null;
  url?: string | null;
  lat?: number | null;
  long?: number | null;
  isPhotoHidden?: boolean | null;
  zhId?: string | null;
  starRating?: number | null;
  googlePlaceId?: string | null;
  isFavorite?: boolean | null;
  category?: Types.AccommodationPlaceCategory | null;
  isHostStayingHere?: boolean | null;
  createdByType: string;
  joyPlaceId?: string | null;
  customName?: string | null;
  customAddress?: string | null;
  customUrl?: string | null;
  customPhone?: string | null;
  isFromAccommodationCatalog: boolean;
  isCustomLinkEnabled?: boolean | null;
  photo?: { __typename?: 'Photo'; id: string; url: string } | null;
  userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
  customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
  distances?: {
    __typename?: 'TravelDistancesBetweenPointsResponse';
    commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }>;
  } | null;
  accommodationRoomBlock?: {
    __typename?: 'AccommodationPlaceRoomBlock';
    bookingUrl: string;
    checkInDate: string;
    checkOutDate: string;
    cutoffDate: string;
    isJoyManagedRoomBlock: boolean;
    numberOfRoomsReserved: number;
    status: Types.AccommodationPlaceRoomBlockStatus;
    pricePerNight?: number | null;
    strikeoutPricePerNight?: number | null;
  } | null;
  autoSuggestionRecommendation?: {
    __typename?: 'AccommodationPlaceRecommendation';
    id: string;
    status: Types.AccommodationPlaceRecommendationStatus;
    whyThisHotelIsAGreatPick?: string | null;
    proposedNoteFromHostToGuest?: string | null;
    highlightTags?: Array<string> | null;
    venueGooglePlaceId?: string | null;
  } | null;
};

export type AccommodationsInfoFragment = {
  __typename?: 'Event';
  id: string;
  accommodationPlacesV2: Array<{
    __typename: 'AccommodationPlaceV2';
    id: string;
    type?: Types.AccommodationPlaceType | null;
    userNote?: string | null;
    name?: string | null;
    description?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    country?: string | null;
    email?: string | null;
    phone?: string | null;
    url?: string | null;
    lat?: number | null;
    long?: number | null;
    isPhotoHidden?: boolean | null;
    zhId?: string | null;
    starRating?: number | null;
    googlePlaceId?: string | null;
    isFavorite?: boolean | null;
    category?: Types.AccommodationPlaceCategory | null;
    isHostStayingHere?: boolean | null;
    createdByType: string;
    joyPlaceId?: string | null;
    customName?: string | null;
    customAddress?: string | null;
    customUrl?: string | null;
    customPhone?: string | null;
    isFromAccommodationCatalog: boolean;
    isCustomLinkEnabled?: boolean | null;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
    customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
    distances?: {
      __typename?: 'TravelDistancesBetweenPointsResponse';
      commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }>;
    } | null;
    accommodationRoomBlock?: {
      __typename?: 'AccommodationPlaceRoomBlock';
      bookingUrl: string;
      checkInDate: string;
      checkOutDate: string;
      cutoffDate: string;
      isJoyManagedRoomBlock: boolean;
      numberOfRoomsReserved: number;
      status: Types.AccommodationPlaceRoomBlockStatus;
      pricePerNight?: number | null;
      strikeoutPricePerNight?: number | null;
    } | null;
    autoSuggestionRecommendation?: {
      __typename?: 'AccommodationPlaceRecommendation';
      id: string;
      status: Types.AccommodationPlaceRecommendationStatus;
      whyThisHotelIsAGreatPick?: string | null;
      proposedNoteFromHostToGuest?: string | null;
      highlightTags?: Array<string> | null;
      venueGooglePlaceId?: string | null;
    } | null;
  }>;
  info: {
    __typename?: 'EventInfo';
    id: string;
    eventDisplayName?: string | null;
    ownerFirstName?: string | null;
    fianceeFirstName?: string | null;
    finalizedDate?: { __typename?: 'Date'; dateString: string } | null;
  };
  photo?: { __typename?: 'Photo'; id: string; url: string } | null;
  travelSettings?: {
    __typename?: 'TravelSettings';
    currencyCode?: Types.TravelCurrencyCode | null;
    checkInDate?: string | null;
    checkOutDate?: string | null;
    accommodationsPageLayout?: Types.AccommodationsPageLayout | null;
    accommodationsNeighborhoodsNote?: string | null;
  } | null;
  hotelRoomBlocks?: {
    __typename?: 'HotelRoomBlocks';
    id: string;
    submittedDateTime?: any | null;
    eventDisplayName?: string | null;
    AnyOtherDetails?: string | null;
    PreferredContactMethod?: Types.ContactMethods | null;
    bookingLink?: string | null;
    leadStateV2?: Types.LeadStateV2 | null;
    leadStateV2UpdatedAt?: any | null;
    checkIn?: any | null;
    checkOut?: any | null;
    email?: string | null;
    numberOfRooms?: string | null;
    concierge?: { __typename?: 'OwnerDetails'; name?: string | null; email?: string | null; photo?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
    destination?: { __typename?: 'LeadDestination'; name?: string | null; lat?: number | null; long?: number | null; postalCode?: string | null; address?: string | null } | null;
  } | null;
};

export type CreateEventPlaceMutationVariables = Types.Exact<{
  payload: Types.EventPlaceCreatePayload;
}>;

export type CreateEventPlaceMutation = {
  __typename?: 'Mutation';
  createEventPlace: {
    __typename?: 'EventPlace';
    id?: string | null;
    googlePlaceId?: string | null;
    type: Types.EventPlaceType;
    name: string;
    displayAddress: string;
    latitude?: number | null;
    longitude?: number | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    countryCode?: string | null;
  };
};

export type UpdateEventPlaceMutationVariables = Types.Exact<{
  payload: Types.EventPlaceUpdatePayload;
}>;

export type UpdateEventPlaceMutation = {
  __typename?: 'Mutation';
  updateEventPlace: {
    __typename?: 'EventPlace';
    id?: string | null;
    googlePlaceId?: string | null;
    type: Types.EventPlaceType;
    name: string;
    displayAddress: string;
    latitude?: number | null;
    longitude?: number | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    countryCode?: string | null;
  };
};

export type DeleteEventPlaceMutationVariables = Types.Exact<{
  deleteEventPlaceId: Types.Scalars['ID'];
}>;

export type DeleteEventPlaceMutation = {
  __typename?: 'Mutation';
  deleteEventPlace: {
    __typename?: 'EventPlace';
    id?: string | null;
    googlePlaceId?: string | null;
    type: Types.EventPlaceType;
    name: string;
    displayAddress: string;
    latitude?: number | null;
    longitude?: number | null;
  };
};

export type DeletePointOnMapMutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.PointsOnMapDeletePayload>;
}>;

export type DeletePointOnMapMutation = { __typename?: 'Mutation'; deletePointOnMap: { __typename?: 'PointsOnMap'; id: string } };

export type AddAccommodationPlaceV2MutationVariables = Types.Exact<{
  payload: Types.AddAccommodationPlaceV2Request;
}>;

export type AddAccommodationPlaceV2Mutation = { __typename?: 'Mutation'; addAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2'; id: string } };

export type UpdateAccommodationPlaceV2MutationVariables = Types.Exact<{
  payload: Types.UpdateAccommodationPlaceV2Request;
}>;

export type UpdateAccommodationPlaceV2Mutation = { __typename?: 'Mutation'; updateAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2'; id: string } };

export type DeleteAccommodationPlaceV2MutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type DeleteAccommodationPlaceV2Mutation = { __typename?: 'Mutation'; deleteAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2'; id: string } };

export type AccommodationHotelsQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type AccommodationHotelsQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    accommodationPlacesV2: Array<{
      __typename: 'AccommodationPlaceV2';
      id: string;
      type?: Types.AccommodationPlaceType | null;
      userNote?: string | null;
      name?: string | null;
      description?: string | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
      country?: string | null;
      email?: string | null;
      phone?: string | null;
      url?: string | null;
      lat?: number | null;
      long?: number | null;
      isPhotoHidden?: boolean | null;
      zhId?: string | null;
      starRating?: number | null;
      googlePlaceId?: string | null;
      isFavorite?: boolean | null;
      category?: Types.AccommodationPlaceCategory | null;
      isHostStayingHere?: boolean | null;
      createdByType: string;
      joyPlaceId?: string | null;
      customName?: string | null;
      customAddress?: string | null;
      customUrl?: string | null;
      customPhone?: string | null;
      isFromAccommodationCatalog: boolean;
      isCustomLinkEnabled?: boolean | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
      customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
      distances?: {
        __typename?: 'TravelDistancesBetweenPointsResponse';
        commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }>;
      } | null;
      accommodationRoomBlock?: {
        __typename?: 'AccommodationPlaceRoomBlock';
        bookingUrl: string;
        checkInDate: string;
        checkOutDate: string;
        cutoffDate: string;
        isJoyManagedRoomBlock: boolean;
        numberOfRoomsReserved: number;
        status: Types.AccommodationPlaceRoomBlockStatus;
        pricePerNight?: number | null;
        strikeoutPricePerNight?: number | null;
      } | null;
      autoSuggestionRecommendation?: {
        __typename?: 'AccommodationPlaceRecommendation';
        id: string;
        status: Types.AccommodationPlaceRecommendationStatus;
        whyThisHotelIsAGreatPick?: string | null;
        proposedNoteFromHostToGuest?: string | null;
        highlightTags?: Array<string> | null;
        venueGooglePlaceId?: string | null;
      } | null;
    }>;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventDisplayName?: string | null;
      ownerFirstName?: string | null;
      fianceeFirstName?: string | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string } | null;
    };
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    travelSettings?: {
      __typename?: 'TravelSettings';
      currencyCode?: Types.TravelCurrencyCode | null;
      checkInDate?: string | null;
      checkOutDate?: string | null;
      accommodationsPageLayout?: Types.AccommodationsPageLayout | null;
      accommodationsNeighborhoodsNote?: string | null;
    } | null;
    hotelRoomBlocks?: {
      __typename?: 'HotelRoomBlocks';
      id: string;
      submittedDateTime?: any | null;
      eventDisplayName?: string | null;
      AnyOtherDetails?: string | null;
      PreferredContactMethod?: Types.ContactMethods | null;
      bookingLink?: string | null;
      leadStateV2?: Types.LeadStateV2 | null;
      leadStateV2UpdatedAt?: any | null;
      checkIn?: any | null;
      checkOut?: any | null;
      email?: string | null;
      numberOfRooms?: string | null;
      concierge?: { __typename?: 'OwnerDetails'; name?: string | null; email?: string | null; photo?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
      destination?: { __typename?: 'LeadDestination'; name?: string | null; lat?: number | null; long?: number | null; postalCode?: string | null; address?: string | null } | null;
    } | null;
  } | null;
};

export type AccommodationTravelLayoutQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type AccommodationTravelLayoutQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: { __typename?: 'TravelSettings'; accommodationsPageLayout?: Types.AccommodationsPageLayout | null } | null;
  } | null;
};

export type UpdateTravelMapComponentMutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.TravelMapComponentUpdatePayload>;
}>;

export type UpdateTravelMapComponentMutation = { __typename?: 'Mutation'; updateTravelMapComponent: { __typename?: 'TravelMapComponent'; id: string } };

export type AccommodationsEditorLeadStateQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type AccommodationsEditorLeadStateQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    featureFlags?: Array<string | null> | null;
    hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks'; id: string; bookingLink?: string | null; leadStateV2?: Types.LeadStateV2 | null } | null;
  } | null;
};

export type AccommodationPropertyPhotosQueryVariables = Types.Exact<{
  payload: Types.AccommodationContentSearchInput;
}>;

export type AccommodationPropertyPhotosQuery = {
  __typename?: 'Query';
  searchAccommodationProperties: {
    __typename?: 'AccommodationContentSearchResult';
    properties: Array<{ __typename?: 'AccommodationCatalogProperty'; joyPlaceId: string; photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string }> }>;
  };
};

export type FindMatchingAccommodationCatalogPropertyQueryVariables = Types.Exact<{
  payload: Types.FindMatchingAccommodationCatalogPropertyPayload;
}>;

export type FindMatchingAccommodationCatalogPropertyQuery = {
  __typename?: 'Query';
  findMatchingAccommodationCatalogProperty?: {
    __typename?: 'FindMatchingAccommodationCatalogPropertyResult';
    accommodationCatalogProperty?: {
      __typename?: 'AccommodationCatalogProperty';
      joyPlaceId: string;
      name: string;
      starRating?: number | null;
      plainTextLongDescription: string;
      userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
      location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
      address?: {
        __typename?: 'AccommodationCatalogPropertyAddress';
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        state?: string | null;
        street?: string | null;
      } | null;
      photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string }>;
    } | null;
  } | null;
};

export const TravelDistanceBetweenPointsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TravelDistancesBetweenPointsResponseFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commonDistance' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationRoomBlockFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationRoomBlock' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationPlaceRecommendationFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'highlightTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'venueGooglePlaceId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationPlaceV2FragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'long' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHostStayingHere' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationRoomBlock' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationRoomBlock' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSuggestionRecommendation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'highlightTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'venueGooglePlaceId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationRoomBlock' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commonDistance' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationsInfoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationsInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationPlacesV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationPlaceV2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'dateString' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accommodationsPageLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accommodationsNeighborhoodsNote' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hotelRoomBlocks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'AnyOtherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'PreferredContactMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStateV2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStateV2UpdatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'concierge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'highlightTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'venueGooglePlaceId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationRoomBlock' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commonDistance' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'long' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHostStayingHere' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationRoomBlock' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationRoomBlock' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSuggestionRecommendation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CreateEventPlaceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEventPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPlaceCreatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventPlace' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEventPlaceMutationFn = Apollo.MutationFunction<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>;

/**
 * __useCreateEventPlaceMutation__
 *
 * To run a mutation, you first call `useCreateEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventPlaceMutation, { data, loading, error }] = useCreateEventPlaceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>(CreateEventPlaceDocument, baseOptions);
}
export type CreateEventPlaceMutationHookResult = ReturnType<typeof useCreateEventPlaceMutation>;
export type CreateEventPlaceMutationResult = Apollo.MutationResult<CreateEventPlaceMutation>;
export type CreateEventPlaceMutationOptions = Apollo.BaseMutationOptions<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>;
export const UpdateEventPlaceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPlaceUpdatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventPlace' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventPlaceMutationFn = Apollo.MutationFunction<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>;

/**
 * __useUpdateEventPlaceMutation__
 *
 * To run a mutation, you first call `useUpdateEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventPlaceMutation, { data, loading, error }] = useUpdateEventPlaceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>(UpdateEventPlaceDocument, baseOptions);
}
export type UpdateEventPlaceMutationHookResult = ReturnType<typeof useUpdateEventPlaceMutation>;
export type UpdateEventPlaceMutationResult = Apollo.MutationResult<UpdateEventPlaceMutation>;
export type UpdateEventPlaceMutationOptions = Apollo.BaseMutationOptions<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>;
export const DeleteEventPlaceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEventPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteEventPlaceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEventPlace' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteEventPlaceId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteEventPlaceMutationFn = Apollo.MutationFunction<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>;

/**
 * __useDeleteEventPlaceMutation__
 *
 * To run a mutation, you first call `useDeleteEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventPlaceMutation, { data, loading, error }] = useDeleteEventPlaceMutation({
 *   variables: {
 *      deleteEventPlaceId: // value for 'deleteEventPlaceId'
 *   },
 * });
 */
export function useDeleteEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>(DeleteEventPlaceDocument, baseOptions);
}
export type DeleteEventPlaceMutationHookResult = ReturnType<typeof useDeleteEventPlaceMutation>;
export type DeleteEventPlaceMutationResult = Apollo.MutationResult<DeleteEventPlaceMutation>;
export type DeleteEventPlaceMutationOptions = Apollo.BaseMutationOptions<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>;
export const DeletePointOnMapDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePointOnMap' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PointsOnMapDeletePayload' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePointOnMap' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeletePointOnMapMutationFn = Apollo.MutationFunction<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>;

/**
 * __useDeletePointOnMapMutation__
 *
 * To run a mutation, you first call `useDeletePointOnMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOnMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOnMapMutation, { data, loading, error }] = useDeletePointOnMapMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeletePointOnMapMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>) {
  return ApolloReactHooks.useMutation<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>(DeletePointOnMapDocument, baseOptions);
}
export type DeletePointOnMapMutationHookResult = ReturnType<typeof useDeletePointOnMapMutation>;
export type DeletePointOnMapMutationResult = Apollo.MutationResult<DeletePointOnMapMutation>;
export type DeletePointOnMapMutationOptions = Apollo.BaseMutationOptions<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>;
export const AddAccommodationPlaceV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddAccommodationPlaceV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddAccommodationPlaceV2Request' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addAccommodationPlaceV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddAccommodationPlaceV2MutationFn = Apollo.MutationFunction<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>;

/**
 * __useAddAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useAddAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccommodationPlaceV2Mutation, { data, loading, error }] = useAddAccommodationPlaceV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>) {
  return ApolloReactHooks.useMutation<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>(AddAccommodationPlaceV2Document, baseOptions);
}
export type AddAccommodationPlaceV2MutationHookResult = ReturnType<typeof useAddAccommodationPlaceV2Mutation>;
export type AddAccommodationPlaceV2MutationResult = Apollo.MutationResult<AddAccommodationPlaceV2Mutation>;
export type AddAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>;
export const UpdateAccommodationPlaceV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccommodationPlaceV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAccommodationPlaceV2Request' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccommodationPlaceV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateAccommodationPlaceV2MutationFn = Apollo.MutationFunction<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>;

/**
 * __useUpdateAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationPlaceV2Mutation, { data, loading, error }] = useUpdateAccommodationPlaceV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateAccommodationPlaceV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>(UpdateAccommodationPlaceV2Document, baseOptions);
}
export type UpdateAccommodationPlaceV2MutationHookResult = ReturnType<typeof useUpdateAccommodationPlaceV2Mutation>;
export type UpdateAccommodationPlaceV2MutationResult = Apollo.MutationResult<UpdateAccommodationPlaceV2Mutation>;
export type UpdateAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>;
export const DeleteAccommodationPlaceV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAccommodationPlaceV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAccommodationPlaceV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteAccommodationPlaceV2MutationFn = Apollo.MutationFunction<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>;

/**
 * __useDeleteAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationPlaceV2Mutation, { data, loading, error }] = useDeleteAccommodationPlaceV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccommodationPlaceV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>,
) {
  return ApolloReactHooks.useMutation<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>(DeleteAccommodationPlaceV2Document, baseOptions);
}
export type DeleteAccommodationPlaceV2MutationHookResult = ReturnType<typeof useDeleteAccommodationPlaceV2Mutation>;
export type DeleteAccommodationPlaceV2MutationResult = Apollo.MutationResult<DeleteAccommodationPlaceV2Mutation>;
export type DeleteAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>;
export const AccommodationHotelsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationHotels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationsInfo' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'highlightTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'venueGooglePlaceId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationRoomBlock' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commonDistance' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationPlaceV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'long' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHostStayingHere' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationRoomBlock' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationRoomBlock' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSuggestionRecommendation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationPlaceRecommendation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationsInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationPlacesV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationPlaceV2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'dateString' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accommodationsPageLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accommodationsNeighborhoodsNote' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hotelRoomBlocks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'AnyOtherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'PreferredContactMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStateV2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStateV2UpdatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'concierge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationHotelsQuery__
 *
 * To run a query within a React component, call `useAccommodationHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationHotelsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationHotelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>) {
  return ApolloReactHooks.useQuery<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>(AccommodationHotelsDocument, baseOptions);
}
export function useAccommodationHotelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>(AccommodationHotelsDocument, baseOptions);
}
export type AccommodationHotelsQueryHookResult = ReturnType<typeof useAccommodationHotelsQuery>;
export type AccommodationHotelsLazyQueryHookResult = ReturnType<typeof useAccommodationHotelsLazyQuery>;
export type AccommodationHotelsQueryResult = Apollo.QueryResult<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>;
export const AccommodationTravelLayoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationTravelLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accommodationsPageLayout' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationTravelLayoutQuery__
 *
 * To run a query within a React component, call `useAccommodationTravelLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationTravelLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationTravelLayoutQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationTravelLayoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationTravelLayoutQuery, AccommodationTravelLayoutQueryVariables>) {
  return ApolloReactHooks.useQuery<AccommodationTravelLayoutQuery, AccommodationTravelLayoutQueryVariables>(AccommodationTravelLayoutDocument, baseOptions);
}
export function useAccommodationTravelLayoutLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationTravelLayoutQuery, AccommodationTravelLayoutQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationTravelLayoutQuery, AccommodationTravelLayoutQueryVariables>(AccommodationTravelLayoutDocument, baseOptions);
}
export type AccommodationTravelLayoutQueryHookResult = ReturnType<typeof useAccommodationTravelLayoutQuery>;
export type AccommodationTravelLayoutLazyQueryHookResult = ReturnType<typeof useAccommodationTravelLayoutLazyQuery>;
export type AccommodationTravelLayoutQueryResult = Apollo.QueryResult<AccommodationTravelLayoutQuery, AccommodationTravelLayoutQueryVariables>;
export const UpdateTravelMapComponentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTravelMapComponent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponentUpdatePayload' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTravelMapComponent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTravelMapComponentMutationFn = Apollo.MutationFunction<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>;

/**
 * __useUpdateTravelMapComponentMutation__
 *
 * To run a mutation, you first call `useUpdateTravelMapComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelMapComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelMapComponentMutation, { data, loading, error }] = useUpdateTravelMapComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTravelMapComponentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>(UpdateTravelMapComponentDocument, baseOptions);
}
export type UpdateTravelMapComponentMutationHookResult = ReturnType<typeof useUpdateTravelMapComponentMutation>;
export type UpdateTravelMapComponentMutationResult = Apollo.MutationResult<UpdateTravelMapComponentMutation>;
export type UpdateTravelMapComponentMutationOptions = Apollo.BaseMutationOptions<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>;
export const AccommodationsEditorLeadStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationsEditorLeadState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hotelRoomBlocks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bookingLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStateV2' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationsEditorLeadStateQuery__
 *
 * To run a query within a React component, call `useAccommodationsEditorLeadStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsEditorLeadStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsEditorLeadStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useAccommodationsEditorLeadStateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>(AccommodationsEditorLeadStateDocument, baseOptions);
}
export function useAccommodationsEditorLeadStateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>(AccommodationsEditorLeadStateDocument, baseOptions);
}
export type AccommodationsEditorLeadStateQueryHookResult = ReturnType<typeof useAccommodationsEditorLeadStateQuery>;
export type AccommodationsEditorLeadStateLazyQueryHookResult = ReturnType<typeof useAccommodationsEditorLeadStateLazyQuery>;
export type AccommodationsEditorLeadStateQueryResult = Apollo.QueryResult<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>;
export const AccommodationPropertyPhotosDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationPropertyPhotos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationContentSearchInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchAccommodationProperties' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photos' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationPropertyPhotosQuery__
 *
 * To run a query within a React component, call `useAccommodationPropertyPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPropertyPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPropertyPhotosQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPropertyPhotosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>) {
  return ApolloReactHooks.useQuery<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>(AccommodationPropertyPhotosDocument, baseOptions);
}
export function useAccommodationPropertyPhotosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>(AccommodationPropertyPhotosDocument, baseOptions);
}
export type AccommodationPropertyPhotosQueryHookResult = ReturnType<typeof useAccommodationPropertyPhotosQuery>;
export type AccommodationPropertyPhotosLazyQueryHookResult = ReturnType<typeof useAccommodationPropertyPhotosLazyQuery>;
export type AccommodationPropertyPhotosQueryResult = Apollo.QueryResult<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>;
export const FindMatchingAccommodationCatalogPropertyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindMatchingAccommodationCatalogProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FindMatchingAccommodationCatalogPropertyPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findMatchingAccommodationCatalogProperty' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationCatalogProperty' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRating' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'plainTextLongDescription' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photos' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFindMatchingAccommodationCatalogPropertyQuery__
 *
 * To run a query within a React component, call `useFindMatchingAccommodationCatalogPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMatchingAccommodationCatalogPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMatchingAccommodationCatalogPropertyQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useFindMatchingAccommodationCatalogPropertyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>,
) {
  return ApolloReactHooks.useQuery<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>(
    FindMatchingAccommodationCatalogPropertyDocument,
    baseOptions,
  );
}
export function useFindMatchingAccommodationCatalogPropertyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>(
    FindMatchingAccommodationCatalogPropertyDocument,
    baseOptions,
  );
}
export type FindMatchingAccommodationCatalogPropertyQueryHookResult = ReturnType<typeof useFindMatchingAccommodationCatalogPropertyQuery>;
export type FindMatchingAccommodationCatalogPropertyLazyQueryHookResult = ReturnType<typeof useFindMatchingAccommodationCatalogPropertyLazyQuery>;
export type FindMatchingAccommodationCatalogPropertyQueryResult = Apollo.QueryResult<
  FindMatchingAccommodationCatalogPropertyQuery,
  FindMatchingAccommodationCatalogPropertyQueryVariables
>;
